/* FRONT PAGE SCRIPTS */

/*Moved to wp-foundation.js to support serving pages*/

// jQuery(document).ready(function($) {	
// 	initPreloaderScreen();
// 	initSliders();		
// 	initLogoSlider();
// 	jQuery(window).resize(function() {
// 		initLogoSlider();
// 	})
// });
// 
// function initPreloaderScreen() {
// 	setTimeout(function(){
// 		jQuery('.home #loader').addClass('animated zoomOut');		
// 	}, 1000);
// 	setTimeout(function(){		
// 		jQuery('.home #loader-wrapper').fadeOut('slow');	
// 		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
// 	}, 1550);
// 	initSubmenus();
// }
// 
// 
// function initSubmenus() {
// 	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
// /*	setTimeout(function(){
// 		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
// 	}, 800); */
// }
// 
// 
// function initSliders(){	
// 	/* https://swiperjs.com/get-started/  */
// 	
// 	var fpImagesSlider = jQuery('#fp-services-images');
// 	if(fpImagesSlider.length) {  
// 		var fpImage = new Swiper ('#fp-services-images' , {
// 			// Optional parameters
// 			direction: 'horizontal',
// 			loop: true,
// 			autoHeight: false,
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 			effect: 'fade',
// 			//init: 'false',
// 			// fadeEffect: {
// 			// 	crossFade: true
// 			// },
// 		})
// 	}
// 	
// 	var fpServicesSlider = jQuery('#fp-services-slider');
// 	if(fpServicesSlider.length) {  
// 		var fpService = new Swiper ('#fp-services-slider' , {
// 			// Optional parameters
// 			direction: 'horizontal',
// 			loop: true,
// 			autoHeight: false,
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 			effect: 'fade',
// 			//init: 'false',
// 			// fadeEffect: {
// 			// 	crossFade: true
// 			// },
// 			// If we need pagination
// 			pagination: {
// 			  el: '.swiper-pagination',
// 			  clickable: true,
// 			  type: 'bullets',
// 			},
// 		
// 			// Navigation arrows
// 			navigation: {
// 			  nextEl: '.swiper-button-next',
// 			  prevEl: '.swiper-button-prev',
// 			},
// 			on: {
// 				slideChange: function () {
// 				  let thisIndex = jQuery(this)[0].activeIndex;
// 				  fpImage.slideTo(thisIndex);
// 				},
// 			  }
// 		})
// 	}
// 	
// 	var fpResourcesImagesSlider = jQuery('#fp-resources-images');
// 	if(fpResourcesImagesSlider.length) {  
// 		var fpResourcesImages = new Swiper ('#fp-resources-images' , {
// 			// Optional parameters
// 			direction: 'horizontal',
// 			loop: true,
// 			autoHeight: false,
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 			effect: 'fade',
// 			//init: 'false',
// 			// fadeEffect: {
// 			// 	crossFade: true
// 			// },
// 		})
// 	}
// 	
// 	var fpResourcesSlider = jQuery('#fp-resources-slider');
// 	if(fpResourcesSlider.length) {  
// 		var fpResources = new Swiper ('#fp-resources-slider' , {
// 			// Optional parameters
// 			direction: 'horizontal',
// 			loop: true,
// 			autoHeight: false,
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 			effect: 'fade',
// 			//init: 'false',
// 			// fadeEffect: {
// 			// 	crossFade: true
// 			// },
// 			// If we need pagination
// 			pagination: {
// 			  el: '.swiper-pagination',
// 			  clickable: true,
// 			  type: 'bullets',
// 			},
// 		
// 			// Navigation arrows
// 			navigation: {
// 			  nextEl: '.swiper-button-next',
// 			  prevEl: '.swiper-button-prev',
// 			},
// 			on: {
// 				slideChange: function () {
// 				  let thisIndex = jQuery(this)[0].activeIndex;
// 				  fpResourcesImages.slideTo(thisIndex);
// 				},
// 			  }
// 		})
// 	}
// 
// 	// var fpcarouselinner = jQuery('.fp-carousel-row-inner');
// 	// if(fpcarouselinner.length) {  
// 	//   var mySwiper = new Swiper ('.fp-carousel-row-inner' , {
// 	//     // Optional parameters
// 	//     direction: 'horizontal',
// 	//     loop: true,
// 	//     autoHeight: true,
// 	//     slidesPerView: 1,
// 	// 	spaceBetween: 10,
// 	// 
// 	//     // If we need pagination
// 	// 		pagination: {
// 	// 		  el: '.swiper-pagination',
// 	// 		  clickable: true,
// 	// 		  type: 'bullets',
// 	// 					
// 	// 		},
// 	// 	
// 	// 		// Navigation arrows
// 	// 		navigation: {
// 	// 		  nextEl: '.swiper-button-next',
// 	// 		  prevEl: '.swiper-button-prev',
// 	// 		},
// 	// 
// 	//     // And if we need scrollbar
// 	//   })
// 	// }
// }	

function initLogoSlider() {
	var fpLogosSlider = jQuery('#fp-logos');
	if(fpLogosSlider.length) {  
		var fpLogos = new Swiper ('#fp-logos' , {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
			autoHeight: false,
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			init: 'false',
			autoplay: {
				delay: 3000,
			 },
		})
	}
	
	if(jQuery(window).width() < 640 && !jQuery('#fp-logos').hasClass('swiper-init')) {
		fpLogos.init();

		jQuery('#fp-logos').addClass('swiper-init');
	} 
	else if(jQuery(window).width() > 639 && !jQuery('#fp-logos').hasClass('swiper-remove')) {
		fpLogos.destroy(); 

		jQuery('#fp-logos').removeClass('swiper-init').addClass('.swiper-remove');
	}
}